module.exports = __webpack_public_path__ + "static/media/Hot Tube.c4bdd6d1.jpg";